import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import styles from './style.module.scss';
import cn from 'classnames';
/**
 * A image component in Figure with Caption. SEO oriented
 *
 * @param	{string}	description		Caption text for this image
 * @param	{string}	alt		        Alternative text for this image
 * @param	{string}	src	          Image phad
 * @param	{string}	maxWidth		  Maximum width of figure element. Default with is 1100px
 * @param	{string}	maxWidth		  Maximum height of figure element. Default with is 400px
 * @param	{string}	textColor	    Color of Caption text
 * @param	{string}	textAlign	    Position of Caption text. Default is right position
 * @param	{bool}	  cutted	      If image width> 1000 px then please 'true', else 'false'
 *
 **/

var FigureImage = function FigureImage(_ref) {
  var _cn;

  var _ref$description = _ref.description,
      description = _ref$description === void 0 ? false : _ref$description,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? '' : _ref$src,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '1100px' : _ref$maxWidth,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? '400px' : _ref$maxHeight,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? 'black' : _ref$textColor,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? 'right' : _ref$textAlign,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'cutted' : _ref$className,
      _ref$cutted = _ref.cutted,
      cutted = _ref$cutted === void 0 ? true : _ref$cutted;
  return React.createElement("figure", {
    style: {
      maxWidth: maxWidth
    },
    className: cn(styles.figure, (_cn = {}, _defineProperty(_cn, styles.cutted, cutted), _defineProperty(_cn, className, className), _cn))
  }, React.createElement("div", {
    style: {
      maxHeight: maxHeight
    }
  }, React.createElement("img", {
    src: src,
    alt: alt,
    itemProp: "image"
  })), description && React.createElement("figcaption", {
    style: {
      textAlign: textAlign,
      color: textColor
    }
  }, description));
};

export default FigureImage;